import { styled } from '@mui/material/styles';

import MUITabs, { type TabsProps } from '@mui/material/Tabs';

const Tabs = (props: TabsProps) => {
    const StyledTabs = styled(MUITabs)({
        borderBottom: '1px solid #e8e8e8',
        borderTop: '1px solid #e8e8e8',
    });

    return <StyledTabs {...props}>{props.children}</StyledTabs>;
};

export default Tabs;
